<template lang="pug">
div
  validation-provider(:rules="requiredTelefones ? 'hasTelefone' : ''", v-slot="{ errors }", :name="nomeAba + '/Telefone(s)'")
    el-table(v-model="telefonesValidationValues" hidden :data="telefones")
  validation-provider(:rules="requiredTelefones ? 'hasTelefone:@' + nomeAba + '/Telefone(s)' : ''", name="$ignoreTelefone$")
    app-label(label="Telefone(s):", :required="requiredTelefones")
    el-input.input(
      label='Telefone',
      v-mask="['(##) #####-####', '(##) ####-####']",
      :class="{'erro' : errorsTelefone && errorsTelefone.length}"
      v-model="fone"
    )
      el-button.style(
        slot="append",
        icon="el-icon-plus",
        @click="addTelefone(fone)",
        :disabled="fone.length < 14",
      )
    span.help.erro {{ errorsTelefone ? errorsTelefone[0] : '' }}

    div.tag-app-input.marginTop
      el-tag(
        v-for="(telefone, index) in telefones",
        :key="index",
        closable,
        type="info",
        size="medium",
        @close="removeTelefone(index)"
      ) {{ telefone }}
</template>

<script>
import AppLabel from '@/components/AppLabel'

export default {

  components: {
    AppLabel
  },

  data () {
    return {
      fone: ''
    }
  },

  props: {
    telefones: {
      type: Array,
      required: true
    },

    // Atenção: workaround para contornar problema na validação do componente de telefone.
    // Use 'delete this.$refs.observer.refs['$ignoreTelefone$']' antes de chamar a validação onde esse componente é usado dentro de um ValidationObserver
    requiredTelefones: {
      type: Boolean,
      default: false
    },

    nomeAba: {
      type: String,
      required: true
    },

    observer: {
      required: true
    }
  },

  computed: {
    errorsTelefone () {
      if (this.observer) {
        return this.observer.errors[ this.nomeAba + '/Telefone(s)' ]
      }
      return []
    },

    telefonesValidationValues () {
      return { telefones: this.telefones }
    }
  },

  methods: {
    addTelefone (fone) {
      this.telefones.push(fone)
      this.fone = ''
    },

    removeTelefone (index) {
      this.telefones.splice(index, 1)
    },

    clearInput () {
      this.fone = ''
    }

  }

}

</script>

<style lang="scss" scoped>

.marginTop {
  margin-top: 5px;
}

/deep/ .tag-app-input i{
  color: #9BA0A9 !important;
}

/deep/ .tag-app-input i:hover {
  color: #F7F7F8 !important;
  background-color: #878D99 !important;
}

/deep/ .el-tag {
  margin-left: 0;
  margin-right: 5px;
  margin-bottom: 5px;
  background-color: #f3f4f5;
  border-color: #dddfe2;
  color: #9ba0a9 ;
}

/deep/ .style {
  color: #9ba0a9 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/AppInputTelefone.vue